




















































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { CalendarEvent } from "vuetify";
import GA from "@/app/modules/_global/classes/Analytics";
import moment from "moment";

@Component({
  components: {
    News: () => import("@/app/modules/news/components/NewsComponent.vue")
  },
  filters: {
    date(value, appLanguage) {
      if (!value) return;

      return moment(value)
        .locale(appLanguage)
        .format("Do MMMM, Y");
    }
  }
})
export default class SchedulePage extends Vue {
  @Prop(Number) readonly tileId!: number;
  @Prop(Boolean) readonly intersecting?: boolean;

  type = "week";

  typeToLabel = {
    month: this.$t("EREPORTER.SCHEDULE.MONTH_VIEW"),
    week: this.$t("EREPORTER.SCHEDULE.WEEK_VIEW"),
    day: this.$t("EREPORTER.SCHEDULE.DAY_VIEW"),
    "4day": this.$t("EREPORTER.SCHEDULE.FOUR_DAY_VIEW")
  };

  weekday: number[] = [1, 2, 3, 4, 5, 6, 0];

  selectedEvent = {};
  selectedElement = null;
  selectedOpen = false;

  value: string = moment().format("YYYY-MM-DD");
  events: CalendarEvent[] = [];

  constructor() {
    super();

    GA.addCustomDimension(1, `${this.userData?.user.id}`);
    GA.trackView(`Schedule: ${this.resource?.contentable?.title}`);
  }

  get appData() {
    return this.$store.getters["app/data"];
  }

  get userData() {
    return this.$store.getters["profile/data"];
  }

  get appLanguage() {
    return this.$store.getters["app/language"];
  }

  get resource() {
    let filteredTile;

    const recursiveFilter = (filter, tiles) => {
      return tiles.filter(tile => {
        if (tile.id == this.tileId) filteredTile = tile;
        if (tile.children) recursiveFilter(filter, tile.children);
      });
    };

    recursiveFilter(tile => tile.id == this.tileId, this.appData.tiles);

    return filteredTile;
  }

  get intervalCount() {
    const _ = this.resource.contentable;
    const differenceInHours = moment
      .duration(moment(_.time_to, "HH:mm").diff(moment(_.time_from, "HH:mm")))
      .asHours();

    return Math.ceil(differenceInHours);
  }

  get unavailable() {
    const massMarket = this.resource.contentable.mass_market;
    return (!massMarket && !this.hasRole("inhabitant")) || this.hasRole("guest");
  }

  getEvents() {
    const events: CalendarEvent[] = [];

    this.$store
      .dispatch("booking/fetchResourceSchedule", {
        id: this.resource.contentable_id,
        date_from: (this.$refs.calendar as CalendarEvent).lastStart.date
      })
      .then(({ data }) => {
        data.data.map(event =>
          events.push({
            name: event.resource.title,
            start: moment(`${event.date_from} ${event.time_from}`).toDate(),
            end: moment(`${event.date_to} ${event.time_to}`).toDate(),
            color: event.status.color,
            timed: !event.is_all_day,

            date_from: event.date_from,
            date_to: event.date_to,
            time_from: event.time_from,
            time_to: event.time_to
          })
        );
      })
      .catch(error => {
        console.log(error);
      });

    this.events = events;
  }

  showDate() {
    this.type = "day";
  }

  showEvent({ nativeEvent, event }) {
    const open = () => {
      this.selectedEvent = event;
      this.selectedElement = nativeEvent.target;
      requestAnimationFrame(() => requestAnimationFrame(() => (this.selectedOpen = true)));
    };

    if (this.selectedOpen) {
      this.selectedOpen = false;
      requestAnimationFrame(() => requestAnimationFrame(() => open()));
    } else {
      open();
    }

    nativeEvent.stopPropagation();
  }

  showTime(event) {
    if (this.unavailable) return;

    const { date, hour } = event;

    this.$router.push({
      name: "booking.reservations.create",
      query: { date, hour }
    });
  }

  hasRole(role: string): boolean {
    return this.userData.roles.some(r => r.slug == role);
  }
}
